import { EnumLanguageType, type TranslationFragment } from '@/core/oddsApi/oddsApiType';
import type { ITranslation } from '@/interface/ITranslation';
import { EnumLanguage } from '@/interface/enum';

export function formatTranslation(translation: TranslationFragment): ITranslation {
    return {
        language: EnumLanguage.fromOddsApi(translation.language ?? EnumLanguageType.EN),
        value: translation.value,
    };
}
